<template>
  <div class="aft">
    <!-- banner -->
    <Banner :banner-h="$t('aftTheSoftware.bannerTitle')" :banner-img="bannerImg1"/>
    <!--    平台介绍-->
    <scroll-animate>
      <div class="main-box">
        <div class="index-tit">
          <h1>{{ $t('aftTheSoftware.title') }}</h1>
          <p>{{ $t('aftTheSoftware.subtitle') }}</p>
        </div>
        <ul class="index-tserver">
          <li class="tserver-list1">
            <span>{{ $t('aftTheSoftware.serviceItems.wechatRepair') }}</span>
            <br/>
            <span>{{ $t('aftTheSoftware.serviceItems.mobileWorkOrder') }}</span>
            <p class="animated zoomin">
              <a href="javascript:void(0)">{{ $t('aftTheSoftware.serviceItems.wechatRepairDesc') }}</a>
            </p>
          </li>
          <li class="tserver-list2">
            <span>{{ $t('aftTheSoftware.serviceItems.customerManagement') }}</span>
            <br/>
            <span>{{ $t('aftTheSoftware.serviceItems.voiceCall') }}</span>
            <p class="animated zoomin">
              <a href="javascript:void(0)">{{ $t('aftTheSoftware.serviceItems.customerManagementDesc') }}</a>
            </p>
          </li>
          <li class="tserver-list3">
            <span>{{ $t('aftTheSoftware.serviceItems.engineerManagement') }}</span>
            <br/>
            <span>{{ $t('aftTheSoftware.serviceItems.areaRefinement') }}</span>

            <p class="animated zoomin">
              <a href="javascript:void(0)">{{ $t('aftTheSoftware.serviceItems.engineerManagementDesc') }}</a>
            </p>
          </li>
          <li class="tserver-list4">
            <span>{{ $t('aftTheSoftware.serviceItems.workOrderManagement') }}</span>
            <br/>
            <span>{{ $t('aftTheSoftware.serviceItems.historyView') }}</span>
            <p class="animated zoomin">
              <a href="javascript:void(0)">{{ $t('aftTheSoftware.serviceItems.workOrderManagementDesc') }}</a>
            </p>
          </li>
          <li class="tserver-list5">
            <span>{{ $t('aftTheSoftware.serviceItems.pcReport') }}</span>
            <p class="animated zoomin">
              <a href="javascript:void(0)">{{ $t('aftTheSoftware.serviceItems.pcReportDesc') }}
              </a>
            </p>
          </li>
        </ul>
      </div>
    </scroll-animate>

    <!--    流程示意-->
    <scroll-animate>
      <div class="flow core_box">
        <div class="fp-tableCell">
          <div class="title">
            <h1 class="title-text">{{ $t('aftTheSoftware.processTitle') }}</h1>
            <p class="title-description">{{ $t('aftTheSoftware.processSubtitle') }}</p>
          </div>
          <div class="inner-item">
            <div class="i-process end">
              <div class="list clearfix">
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <p>{{ $t('aftTheSoftware.processSteps.submitWorkOrder') }}</p>
                  <div class="light por"></div>
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.submitWorkOrderDesc') }}</div>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.acceptWorkOrderDesc') }}</div>
                  <div class="light por"></div>
                  <p>{{ $t('aftTheSoftware.processSteps.acceptWorkOrder') }}</p>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <p>{{ $t('aftTheSoftware.processSteps.assignWorkOrder') }}</p>
                  <div class="light por"></div>
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.assignWorkOrderDesc') }}</div>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.acceptOrderDesc') }}</div>
                  <div class="light por"></div>
                  <p>{{ $t('aftTheSoftware.processSteps.acceptOrder') }}</p>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <p>{{ $t('aftTheSoftware.processSteps.returnOrder') }}</p>
                  <div class="light por"></div>
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.returnOrderDesc') }}</div>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.closeOrderDesc') }}</div>
                  <div class="light por"></div>
                  <p>{{ $t('aftTheSoftware.processSteps.closeOrder') }}</p>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <p>{{ $t('aftTheSoftware.processSteps.satisfactionCall') }}</p>
                  <div class="light por"></div>
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.satisfactionCallDesc') }}</div>
                </div>
                <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
                  <div class="circle por t-f fl">{{ $t('aftTheSoftware.processSteps.finalizePaymentDesc') }}</div>
                  <div class="light por"></div>
                  <p>{{ $t('aftTheSoftware.processSteps.finalizePayment') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroll-animate>

    <!--    平台展示-->
    <scroll-animate>
      <div class="coTenet core_box">
        <img src="@/assets/img/platform/platform_fw.png">
      </div>
    </scroll-animate>

  </div>
</template>

<script>
import $ from "jquery";
import Banner from "@/components/banner.vue";
import ScrollAnimate from "../../components/ScrollAnimate.vue";


export default {
  name: "aftTheSoftware",
  components: {ScrollAnimate, Banner},
  data() {
    return {
      bannerImg1: require("@/assets/img/banner-bg/bananer-mountain.png"),
      LightNum: 0
    }
  },
  mounted() {
    $(function () {
      $(".i-process .btn").eq(0).addClass("cur")

      let LightNum = 0
          , LightAuto = setInterval(function () {
        LightNum++;

        if (LightNum == $(".i-process .btn").length) {
          LightNum = 0
        }

        $(".i-process .btn").eq(LightNum).addClass("cur").siblings().removeClass("cur")
      }, 2000);

    });
  }
}
</script>

<style scoped lang="scss">
/*平台简介*/
.main-box {
  max-width: 1200px;
  height: auto;
  margin: 0 auto
}

.index-tit {
  padding: 40px 0;
  text-align: center
}

.index-tit h1 {
  font-size: 30px;
  color: #363f45;
  font-weight: normal
}

.index-tit p {
  font-size: 20px;
  color: #abb0b4;
  padding-top: 15px
}

.index-tserver {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  padding: 0 2.6%
}

.index-tserver li {
  width: 162px;
  height: 162px;
  text-align: center;
  box-sizing: border-box;
  font-size: 16px;
  color: #656d73;
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-top: 65px;
  margin-bottom: 10px;
  margin-left: 10px;
  background: white;
  border-radius: 81px;
  box-shadow: 0 3px 2px #444444;
}

.index-tserver li span:nth-child(1) {
}

.index-tserver li p {
  width: 162px;
  height: 162px;
  display: inline-block;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -81px;
  border-radius: 81px;
  padding: 40px 30px;
  box-sizing: border-box;
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  background: linear-gradient(111deg, #04bde4, #1067fe);
  display: none
}

.index-tserver li p a {
  color: #fff
}

.index-tserver li p.animated {
  animation-duration: .5s;
  animation-fill-mode: both
}

.index-tserver li:hover p {
  display: block
}

.index-tserver-ad li {
  display: inline-block;
  color: #abb0b4;
  font-size: 16px;
  padding: 0 3%
}

.index-tserver-ad li img {
  vertical-align: middle;
  display: inline-block;
  margin-right: 5px
}

.index-tserver-ad li + li {
  border-left: 1px solid #e2e3e4
}

.zoomin {
  animation-name: zoomin
}

@keyframes zoomin {
  0% {
    opacity: 0;
    transform: scale(.3)
  }
  50% {
    opacity: 1
  }
}

/*服务流程*/

/* 必要布局样式css */
.i-process .list {
  background: #fff url("../../assets/img/platform/ic_background/line.png") no-repeat center;
  margin: 0 auto;
  width: 1200px;
  height: 333px;
}

.fl {
  float: left;
  display: inline;
}

.fr {
  float: right;
  display: inline;
}

.por {
  position: relative;
}

.poa {
  position: absolute;
}

.flow, .cooperation {
  background-color: #fff;
}

.flow {
  margin: 0 auto;
  margin-top: 5rem;
  padding: 3rem 0;
  text-align: center;
  @media screen and (max-width: 1190px) {
    display: none;
  }
}

.fp-tableCell {
  @media screen and (max-width: 1190px) {
    display: none;
  }
}

.title {
  padding: 60px 0 80px 0;
}

.title-text {
  position: relative;
  padding-bottom: 20px;
  font-size: 34px;
  color: #666666;
  font-weight: normal;
}

.title-text:after {
  content: '';
  display: block;
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 110px;
  height: 6px;
  margin-left: -52px;
  background-color: $shanMai_blue;
}

.title-description {
  margin-top: 40px;
  color: #b0b0b0;
}

.title-description {
  margin-top: 30px;
}

.inner-item {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.i-process {
  position: relative;
  left: -15px;
  width: 1200px;
  margin: 0 auto;
}

.i-process .hold {
  width: 1106px;
  height: 352px;
  margin: 0 auto;
}

.i-process .btn {
  width: 68px;
  height: 150px;
  line-height: 2;
  color: black;
  text-align: center;
  transform: translateX(50px);
  opacity: 0;
}

.i-process .btn.cur {
  color: #43cdab;
}

.i-process .btn:nth-child(1) {
  left: 33px;
  top: 165px;
}

.i-process .btn:nth-child(2) {
  left: 151px;
  top: 61px;
}

.i-process .btn:nth-child(3) {
  left: 294px;
  top: 117px;
}

.i-process .btn:nth-child(4) {
  left: 439px;
  top: 46px;
}

.i-process .btn:nth-child(5) {
  left: 618px;
  top: 54px;
}

.i-process .btn:nth-child(6) {
  left: 776px;
  top: 46px;
}

.i-process .btn:nth-child(7) {
  left: 957px;
  top: 148px;
}

.i-process .btn:nth-child(8) {
  left: 1087px;
  top: 58px;
}

.i-process .btn .light {
  float: left;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: #fff;
  margin: 12px 29px;
}

.i-process .btn .light:after {
  content: "";
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: -1;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: #43cdab;
  opacity: 0.3;
}

.i-process .btn.cur .light:after {
  animation: Circle 1.2s infinite linear;
}

.i-process .btn.cur .light:after {
  animation: Circle 1.2s infinite linear;
}

.i-process .btn .circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 15px;
  background: #edeff1;
  padding: 0 10px;
  color: #444444;
  font-size: 12px;
}

.i-process .btn.cur .circle {
  background: #43cdab;
}

.i-process .btn .circle:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 68px;
  height: 68px;
}


.i-process {
  /* height: 350px; */
}

.w-f {
  width: 100%;
}

.h-f {
  height: 100%;
}

.fwn {
  font-weight: normal;
}

.tac {
  text-align: center;
}

.t-f {
  transition: all 0.5s;
}

.t-c {
  transition: color 0.5s;
}

.t-bg {
  transition: background 0.5s;
}

@keyframes Circle {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  50% {
    transform: scale(1);
    opacity: 0.3;
  }

  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

/*平台展示*/
.coTenet {
  margin: 0 auto;
  background-color: white;
  padding-bottom: 50px;
  margin-bottom: 100px;
}

.coTenet > img {
  width: 100%;
}
</style>
